var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"src":require("../assets/video.mp4"),"controls":""}})}
var staticRenderFns = []

export { render, staticRenderFns }